import { http } from 'http';

export default {
  postLoginIdentity: ({ user, password }) =>
    http.post('/login-url', { provider: 'ids', user, password }, { withCredentials: true }),

  postUserSession: payload => http.post('/user-session', payload, { withCredentials: true }),

  recoveryPassword: ({ email }) => http.post('/driversweb/drivers/recoverypassword', { email }),

  changePassword: ({ password, newPassword, idDriver }) =>
    http.post('/driversweb/drivers/ChangePassword', { password, newPassword, idDriver }),

  newDriver: ({ email, dni, plate }) =>
    http.post('/driversweb/drivers/newdriver', { email, dni, plate })
};
